import { useEffect, useState } from 'react'
import { api } from '../api.js'

// Choisir une rubrique plutôt que la taper.
//
// Une rubrique saisie à la main crée une section sur le portail. « Cadre de vie
// et voirie » écrit une fois sans accent en crée une deuxième, et l'habitant
// voit deux listes presque identiques sans comprendre pourquoi. On propose donc
// ce qui existe déjà, et créer une rubrique devient un geste explicite.
export default function ChoisirRubrique({ valeur, onChange, id = 'rubrique' }) {
  const [data, setData] = useState(null)
  const [nouvelle, setNouvelle] = useState('')

  useEffect(() => {
    api.rubriques().then((r) => {
      setData(r)
      // Sans valeur de départ, on propose la rubrique la plus utilisée : c'est
      // le choix juste dans la plupart des cas, et il reste modifiable.
      if (!valeur) onChange(r.utilisees[0]?.nom || r.proposees[0] || 'Autres démarches')
    }).catch(() => setData(null))
  }, [])   // eslint-disable-line

  if (!data) {
    return (
      <div className="champ">
        <label htmlFor={id}>Dans quelle rubrique ?</label>
        <input id={id} value={valeur} onChange={(e) => onChange(e.target.value)} />
      </div>
    )
  }

  const connues = [...data.utilisees.map((r) => r.nom), ...data.proposees]
  const inconnue = valeur && !connues.includes(valeur)

  if (nouvelle !== '' || inconnue) {
    return (
      <div className="champ">
        <label htmlFor={id}>Nom de la nouvelle rubrique</label>
        <input id={id} autoFocus value={valeur}
               placeholder="Eau et assainissement"
               onChange={(e) => onChange(e.target.value)} />
        <p className="aide">Elle apparaîtra comme une nouvelle section sur votre portail.</p>
        <button className="lien-mini" onClick={() => {
          setNouvelle('')
          onChange(data.utilisees[0]?.nom || data.proposees[0] || '')
        }}>Reprendre une rubrique existante</button>
      </div>
    )
  }

  return (
    <div className="champ">
      <label htmlFor={id}>Dans quelle rubrique ?</label>
      <select id={id} value={valeur}
              onChange={(e) => {
                if (e.target.value === '__nouvelle') { setNouvelle(' '); onChange('') }
                else onChange(e.target.value)
              }}>
        {data.utilisees.length > 0 && (
          <optgroup label="Vos rubriques">
            {data.utilisees.map((r) => (
              <option key={r.nom} value={r.nom}>
                {r.nom} ({r.n} démarche{r.n > 1 ? 's' : ''})
              </option>
            ))}
          </optgroup>
        )}
        {data.proposees.length > 0 && (
          <optgroup label="Rubriques courantes en mairie">
            {data.proposees.map((r) => <option key={r} value={r}>{r}</option>)}
          </optgroup>
        )}
        <option value="__nouvelle">Créer une rubrique…</option>
      </select>
      <p className="aide">Les habitants trouvent les démarches par rubrique : mieux vaut peu de
        rubriques bien remplies que beaucoup de rubriques à une seule démarche.</p>
    </div>
  )
}
